<app-auth-layout [loading]="loading">
  <form
    ngNativeValidate
    (ngSubmit)="switchWard()"
    class="flex flex-col h-full p-8 md:p-12"
  >
    <h1
      class="font-bold py- text-center text-lg pb-4 uppercase md:text-xl md:pb-8 lg:text-2xl"
    >
      Switch Ward Profile
    </h1>

    <app-notification-alert [data]="notification"></app-notification-alert>

    <label class="block">
      <div class="font-bold text-grey-darker text-sm mb-2 block">
        Ward
      </div>
      <select name="StateAddress" [(ngModel)]="payload.StudentNo" class="w-full p-1 focus:outline-none">
        <option disabled value="">Select Ward</option>
        <option *ngFor="let ward of wards" [value]="ward.StudentNo" [selected]="ward.StudentNo == payload.StudentNo">
          {{ ward.FullName }}
        </option>
      </select>
    </label>

    <div class="py-8">
      <app-button-primary type="submit" [disabled]="loading" class="w-full">
        Switch Profile
      </app-button-primary>
    </div>
  </form>
</app-auth-layout>
